import axios from "axios";
import { USER_SESSION } from "../helper/SecurityHelper";
import * as securityHelper from "../helper/SecurityHelper";

export const fn_loginHandlerCallback = async (user: any, navigate: any, isFromSignUp?: any, selectedSctrGb?: any) => {

  const auth = user.auth;
  let wrkDclrSeqArr: any = [];
  let smartTbmSeqArr: any = [];
  let wrkDclrSeqStr;
  let smartTbmSeqStr;

  if (auth === 'KOX' || auth === 'COM') {
    // 출근시간 기록

    await axios.post('admin/api/tbm/registMngrTbmData', { userSeq: user.seq, cmpnySeq: user.companySeq });
    navigate('/main');
  } else if (auth === 'SRV' || auth === 'WOK') {
    // 진행 중단한 TBM 있는지 확인
    const tbmIncmplt = await fn_retrieveTbmIncmplt(user.seq);
    if (tbmIncmplt.length > 0) {
      tbmIncmplt.map((wrkDclrData: any) => {
        wrkDclrSeqArr.push(wrkDclrData.wrkDclrSeq);
        smartTbmSeqArr.push(wrkDclrData.smartTbmSeq);
      });
      wrkDclrSeqStr = wrkDclrSeqArr.join();
      smartTbmSeqStr = smartTbmSeqArr.join();

      const wrkDclrList = await fn_retrieveTodayWrkDclrDtl(wrkDclrSeqArr);
      user.wrkDclrSeq = wrkDclrSeqStr;
      user.smartTbmSeq = smartTbmSeqStr;
      sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
      navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeqStr, wrkDclrList: wrkDclrList, authChange: false } });
      return;
    }
    // TBM 완료 시
    const tbmData = await fn_retrieveTbmWrkTime(user.seq);
    wrkDclrSeqArr = [];
    smartTbmSeqArr = [];
    // 작업 중
    if(tbmData.length > 0) {
      if(tbmData[0].workStrtTime && !tbmData[0].workEndTime) {
        tbmData.map((data:any) => {
          wrkDclrSeqArr.push(data.wrkDclrSeq);
          smartTbmSeqArr.push(data.smartTbmSeq);
          user.companySeq = data.cmpnySeq;
          user.companyName = data.cmpnyNm;
          user.companyRegNum = data.regNum;
          user.representative = data.representative;
        })
        wrkDclrSeqStr = wrkDclrSeqArr.join();
        smartTbmSeqStr = smartTbmSeqArr.join();
        user.wrkDclrSeq = wrkDclrSeqStr;
        user.smartTbmSeq = smartTbmSeqStr;
        sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
        navigate('/main');
        return;
        // 작업 완료
      } else if (tbmData[0].workStrtTime && tbmData[0].workEndTime) {
        tbmData.map((data:any) => {
          wrkDclrSeqArr.push(data.wrkDclrSeq);
          smartTbmSeqArr.push(data.smartTbmSeq);
        })
        wrkDclrSeqStr = wrkDclrSeqArr.join();
        smartTbmSeqStr = smartTbmSeqArr.join();
        user.wrkDclrSeq = wrkDclrSeqStr;
        user.smartTbmSeq = smartTbmSeqStr;
        sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
        navigate('/main', {state: {workEnd: true}})
        return;
      }
    }
    // TBM 미완료 시
    // 현장대리인
    if (auth === 'SRV') {
      if (user.apprYn === 'W') {
        alert('홀매니저의 현장대리인 승인 후 계정사용이 가능합니다.');
        sessionStorage.removeItem(USER_SESSION);
        window.location.href = "/";
        return;
      }
      // 유저(현장대리인)가 포함된 작업 신고서 조회
      const wrkDclrListSrv = await fn_retrieveTodaySrvWrkDclrJob(user.seq);
      wrkDclrSeqArr = [];
      smartTbmSeqArr = [];
      wrkDclrListSrv.map((wrkDclrData: any) => {
        wrkDclrSeqArr.push(wrkDclrData.wrkDclrSeq);
        smartTbmSeqArr.push(wrkDclrData.smartTbmSeq);
      });
      // 유저가 포함된 작업 신고서 1개 이상 : TBM 시작
      if (wrkDclrListSrv.length >= 1) {
        // tbm init register 하기
        wrkDclrSeqStr = wrkDclrSeqArr.join();
        smartTbmSeqStr = smartTbmSeqArr.join();

        user.wrkDclrSeq = wrkDclrSeqStr;
        user.smartTbmSeq = smartTbmSeqStr;
        sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
        navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeqStr, wrkDclrList: wrkDclrListSrv, authChange: false } });
        return;
        // 유저가 포함된 작업 신고서 없을 때
      } else if (wrkDclrListSrv.length === 0) {
        // ** 작업자 권한으로 진행 **
        user.auth = 'WOK';
        user.authSeq = 4;
        // 작업자 명단에 올라가 있을 때
        const wrkDclrListWok = await fn_retrieveTodayWrkDclrJob(user.phone);
        wrkDclrSeqArr = [];
        smartTbmSeqArr = [];

        wrkDclrListWok.map((wrkDclrData: any) => {
          wrkDclrSeqArr.push(wrkDclrData.wrkDclrSeq);
          smartTbmSeqArr.push(wrkDclrData.smartTbmSeq);
        })
        // 유저가 포함된 작업 신고서 1개 이상 : TBM 시작
        if (wrkDclrListWok.length >= 1) {
          // tbm init register 하기
          wrkDclrSeqStr = wrkDclrSeqArr.join();
          smartTbmSeqStr = smartTbmSeqArr.join();
          user.wrkDclrSeq = wrkDclrSeqStr;
          user.smartTbmSeq = smartTbmSeqStr;
          sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
          navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeqStr, wrkDclrList: wrkDclrListWok, authChange: true } });
          return;
          // 작업 신고서 미포함
        } else if (wrkDclrListWok.length === 0) {
          // 회사의 작업 신고서가 있을 때
          const wrkDclrListCmpnySrv = await fn_retrieveTodayCmpnyWrkDclrJob(user.seq, user.companySeq);
          wrkDclrSeqArr = [];
          wrkDclrListCmpnySrv.map((wrkDclrData: any) => {
            wrkDclrSeqArr.push(wrkDclrData.wrkDclrSeq);
          });
          // 회사의 작업 신고서 1개일 때, TBM으로 바로 이동
          if (wrkDclrListCmpnySrv.length === 1) {
            // tbm init register 하기
            let wrkDclrData = wrkDclrListCmpnySrv[0];
            const smartTbmSeq = await axios.post('admin/api/tbm/registInitSmrtTbmData', { userSeq: user.seq, userNm: user.name, userPhone: user.phone, authSeq: 4, cmpnySeq: wrkDclrData.cmpnySeq, evntSeq: wrkDclrData.evntSeq, sctrGb: wrkDclrData.sctrGb, wrkDclrSeq: wrkDclrData.wrkDclrSeq })
            user.wrkDclrSeq = wrkDclrData.wrkDclrSeq;
            user.smartTbmSeq = smartTbmSeq.data;
            sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
            navigate('/smart-TBM', {state: { smartTbmSeq: smartTbmSeq.data, wrkDclrList: wrkDclrListCmpnySrv }})
            return;
            // 회사의 작업 신고서 2개 이상일 때, TBM list 작업 선택 화면으로 이동
          } else if (wrkDclrListCmpnySrv.length > 1) {
            sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
            navigate('/smart-TBM-list', {state: { exbtPlc: false, wrkDclrList: wrkDclrListCmpnySrv }})
            return;
            // 회사의 작업 신고서가 없을 때 : 전시장소 선택화면으로 이동(행사 선택)
          } else if (wrkDclrListCmpnySrv.length === 0) {
            sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
            navigate('/smart-TBM-list', { state: { exbtPlc: true, wrkDclrList: null } });
          }
        }
      }
    // 작업자
    } else if (auth === 'WOK') {
      // 유저(작업자)가 포함된 작업 신고서 조회
      const wrkDclrListWok = await fn_retrieveTodayWrkDclrJob(user.phone);
      wrkDclrSeqArr = [];
      smartTbmSeqArr = [];

      wrkDclrListWok.map((wrkDclrData: any) => {
        wrkDclrSeqArr.push(wrkDclrData.wrkDclrSeq);
        smartTbmSeqArr.push(wrkDclrData.smartTbmSeq);
      })
      // 유저가 포함된 작업 신고서 1개 이상 : TBM 시작
      if (wrkDclrListWok.length >= 1) {

        // 유저 직전 회사 검색해서 다를 때 : 직전 회사 찾아오기
        const mostRcntCmpnySeq = await axios.post('admin/api/tbm/retrieveMostRcntCmpnySeq', {userSeq: user.seq});
        // 유저 작업 history 저장하기 + 유저 companySeq 바꿔주기
        if (mostRcntCmpnySeq.data.cmpnySeq !== wrkDclrListWok[0].cmpnySeq) {
          const rsltData = await axios.post("admin/api/tbm/changeUserCmpnyBlng", { userSeq: user.seq, cmpnySeq: wrkDclrListWok[0].cmpnySeq })
          if (rsltData.data > 0) {
            user.companySeq = wrkDclrListWok[0].cmpnySeq;
            sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
          }
        }
        // tbm init register 하기
        wrkDclrSeqStr = wrkDclrSeqArr.join();
        smartTbmSeqStr = smartTbmSeqArr.join();
        user.wrkDclrSeq = wrkDclrSeqStr;
        user.smartTbmSeq = smartTbmSeqStr;
        sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
        navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeqStr, wrkDclrList: wrkDclrListWok, authChange: false } });
        return;
        // 작업 신고서 미포함
      } else if (wrkDclrListWok.length === 0) {
        // 회원가입 경로
        if (isFromSignUp) {
          // 회사의 작업 신고서가 있을 때
          const wrkDclrListCmpnyWok = await fn_retrieveTodayCmpnyWrkDclrJob(user.seq, user.companySeq);
          wrkDclrSeqArr = [];
          wrkDclrListCmpnyWok.map((wrkDclrData: any) => {
            wrkDclrSeqArr.push(wrkDclrData.wrkDclrSeq);
          });
          // 작업 신고서 1개일 때, TBM으로 바로 이동
          if (wrkDclrListCmpnyWok.length === 1) {
            // 회원가입 : 최초 작업이기 때문에, 유저 작업 history 저장하기
            await axios.post("admin/api/tbm/changeUserCmpnyBlng", { userSeq: user.seq, cmpnySeq: user.companySeq })
            // tbm init register 하기
            let wrkDclrData = wrkDclrListCmpnyWok[0];
            const smartTbmSeq = await axios.post('admin/api/tbm/registInitSmrtTbmData', {
              userSeq: user.seq,
              authSeq: 4,
              cmpnySeq: wrkDclrData.cmpnySeq,
              evntSeq: wrkDclrData.evntSeq,
              sctrGb: wrkDclrData.sctrGb,
              wrkDclrSeq: wrkDclrData.wrkDclrSeq,
              userNm: user.name,
              userPhone: user.phone
            })
            user.wrkDclrSeq = wrkDclrData.wrkDclrSeq;
            user.smartTbmSeq = smartTbmSeq.data;
            sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
            navigate('/smart-TBM', {state: { smartTbmSeq: smartTbmSeq.data, wrkDclrList: wrkDclrListCmpnyWok, authChange: false }})
            return;
          // 작업 신고서 2개 이상일 때, TBM list 작업 선택 화면으로 이동
          } else if (wrkDclrListCmpnyWok.length > 1) {
            navigate('/smart-TBM-list', {state: { exbtPlc: false, wrkDclrList: wrkDclrListCmpnyWok }})
            return;
          // 회사의 작업 신고서가 없을 때 : 전시장소 선택화면으로 이동(행사 선택)
          } else if (wrkDclrListCmpnyWok.length === 0) {
            navigate('/smart-TBM-list', { state: { exbtPlc: true, wrkDclrList: null, sctrGb: selectedSctrGb } });
            return;
          }
        // 회원 : 업체 선택 화면으로 이동(최근 업체)
        } else {
          navigate('/smart-TBM-list', { state: { exbtPlc: false, wrkDclrList: null } });
          return;
        }
      }
    }
  }
}

/**
 * TBM 미완료 상태 조회
 * @param userSeq
 */
export const fn_retrieveTbmIncmplt = async (userSeq: bigint) => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveTbmIncmplt', { userSeq: userSeq })
  return rtrnData.data;
}

/**
 * 가장 최근 TBM 조회
 * @param userSeq
 */
export const fn_retrieveRcntTbm = async (userSeq: bigint) => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveRcntTbm', { userSeq: userSeq })
  return rtrnData.data;
}

/**
 * 개인 작업 시간 조회
 * @param userSeq
 */
export const fn_retrieveTbmWrkTime = async (userSeq: bigint) => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveTbmWrkTime', { userSeq: userSeq })
  return rtrnData.data;
}

/**
 * 당일 작업자가 포함된 작업신고서 리스트
 * @param userName
 * @param userPhone
 */
export const fn_retrieveTodayWrkDclrJob = async (userPhone: string) => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveTodayWrkDclrJobCnt', { userPhone });
  return rtrnData.data;
}

/**
 * 당일 현장대리인이 포함된 작업신고서 리스트
 * @param userSeq
 */
export const fn_retrieveTodaySrvWrkDclrJob = async (userSeq: number) => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveTodaySrvWrkDclrJobCnt', { userSeq });
  return rtrnData.data;
}

/**
 * 오늘 회사에 작업 신고서 포함된 갯수 조회
 * @param userName
 */
export const fn_retrieveTodayCmpnyWrkDclrJob = async (userSeq: number, cmpnySeq: number) => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveTodayCmpnyWrkDclrJobCnt', { userSeq, cmpnySeq });
  return rtrnData.data;
}

/**
 * 작업신고서로 세부 데이터 조회
 * @param wrkDclrSeq
 */
export const fn_retrieveTodayWrkDclrDtl = async (wrkDclrSeqArr: any) => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveTodayWrkDclrDtl', { wrkDclrSeqArr });
  return rtrnData.data;
}

/**
 * 스마트 TBM 데이터 삭제
 * @param userSeq
 */
export const fn_deleteSmrtTbmData = async (userSeq:number) => {
  const rtrnData = await axios.post('admin/api/tbm/deleteSmrtTbmData', { userSeq });
  return rtrnData.data;
}